import { Card } from "../_shared";

export function Section({ title, testid, children, full }) {
  return (
    <Card
      className={`p-5 ${full ? "lg:col-span-3" : "lg:col-span-1"}`}
      testid={`admin-assessment-${testid}`}
    >
      <h2 className="text-sm font-medium text-slate-900 mb-3">{title}</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2 text-sm">
        {children}
      </div>
    </Card>
  );
}

export function Field({ label, value, multiline }) {
  const empty = value === null || value === undefined || value === "";
  return (
    <div className={multiline ? "md:col-span-2" : ""}>
      <div className="text-xs uppercase tracking-wide text-slate-500">
        {label}
      </div>
      <div
        className={`mt-0.5 ${
          empty
            ? "text-sm text-slate-400 italic"
            : multiline
              ? "text-sm text-slate-800 whitespace-pre-wrap leading-relaxed"
              : "text-sm text-slate-800"
        }`}
      >
        {empty ? "—" : String(value)}
      </div>
    </div>
  );
}

export function Row({ label, children }) {
  return (
    <div className="flex items-baseline justify-between gap-3">
      <dt className="text-xs uppercase tracking-wide text-slate-500">{label}</dt>
      <dd className="text-sm text-slate-800 text-right max-w-[60%] truncate">
        {children || "—"}
      </dd>
    </div>
  );
}
